import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, Observable, throwError } from 'rxjs';

import { AppRoute } from '@core/navigation/app-route.enum';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(error => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.ServiceUnavailable) {
          this.router.navigate([AppRoute.maintenance]);
        }
        return throwError(error);
      })
    );
  }
}
